import axios from 'axios';

export function submitForm(data) {
  const url = 'dpbusiness/api/client/login';
  return axios.get(url, {params: data}).then((res) => Promise.resolve(res.data))
}

export function getNvrList() {
  const url = 'dpbusiness/api/client/auth/getNvrList';
  return axios.get(url).then((res) => Promise.resolve(res.data))
}

export function getPassengerFlowList() {
  const url = 'dpbusiness/api/client/auth/getPassengerFlowList';
  return axios.get(url).then((res) => Promise.resolve(res.data))
}

export function getSameDayStatistics() {
  const url = 'dpbusiness/api/client/auth/getSameDayStatistics';
  return axios.get(url).then((res) => Promise.resolve(res.data))
}

export function getSameDayStatisticsTime() {
  const url = 'dpbusiness/api/client/auth/getSameDayStatisticsTime';
  return axios.get(url).then((res) => Promise.resolve(res.data))
}

export function passengerFlow() {
  const url = 'dpbusiness/api/client/auth/passengerFlow';
  return axios.get(url).then((res) => Promise.resolve(res.data))
}

export function getParkingSpace() {
  const url = 'dpbusiness/api/client/auth/getParkingSpace';
  return axios.get(url).then((res) => Promise.resolve(res.data))
}



// WEBPACK FOOTER //
// ./src/api/statistics/statistics.js